import React from 'react'
import Modal, { CloseButton } from '@jarvis.oddle/core/components/Modal'
import { H4 } from '@jarvis.oddle/core/components/Typo'
import Form from '@jarvis.oddle/core/components/Form'
import { getPasswordError, getRePasswordError } from '@jarvis.oddle/core/tools/validation'
import { TranslationContext } from '@jarvis.oddle/core/components/Translation'
import { makeControlledModal } from 'src/decorators/ModalController'

const ChangePasswordModal = ({
  modal,
  onChangePassword
}: {
  modal: {
    show: boolean
    onClose: (handler?) => void
    onClosed: () => void
  }
  onChangePassword: (values) => Promise<{
    success: boolean
    error: unknown
  }>
}) => {
  const { t } = React.useContext(TranslationContext)

  const validateForm = (values) => {
    const { password, newPassword, reNewPassword } = values

    const errors = {} as {
      password: string
      newPassword: string
      reNewPassword: string
    }

    const passwordError = getPasswordError(t, password)
    if (passwordError) errors.password = passwordError

    const newPasswordError = getPasswordError(t, newPassword)
    if (newPasswordError) errors.newPassword = newPasswordError

    const reNewPasswordError = getRePasswordError(t, newPassword, reNewPassword, true)
    if (reNewPasswordError) errors.reNewPassword = reNewPasswordError

    return errors
  }

  const onSubmit = async (values, actions) => {
    const response = await onChangePassword(values)
    if (response.success) {
      modal.onClose()
    } else {
      actions.setFieldError('general', response.error)
      actions.setSubmitting(false)
    }
  }

  return (
    <Modal {...modal}>
      <Form
        onValidate={validateForm}
        onSubmit={onSubmit}>
        <Modal.FlexContainer>
          <Modal.Header>
            <H4 margin='none' bold>{t('Change Password')}</H4>
            <CloseButton onClick={modal.onClose} />
          </Modal.Header>
          <Modal.Body>
            <Modal.Section flexShrink={0}>
              <Form.ErrorMessage>
                {({ errors }) => errors.general ? t(errors.general) : null}
              </Form.ErrorMessage>
              <Form.Password name='password' label={t('Current Password')} />
              <Form.Password name='newPassword' label={t('New Password')} />
              <Form.Password name='reNewPassword' label={t('Re-enter New Password')} />
            </Modal.Section>
          </Modal.Body>
          <Modal.Footer>
            <Form.SubmitButton fullWidth>{t('Save')}</Form.SubmitButton>
          </Modal.Footer>
        </Modal.FlexContainer>
      </Form>
    </Modal>
  )
}

export default makeControlledModal(ChangePasswordModal, 'ChangePasswordModal')
